import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { FormGroupDirective, ControlContainer, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Sgkc007aRequest, Sgkc009aRequest, Sgkc008aRequest, TankatableBasicInfo, TankatableMeisaiDto, TankatableregistrationManageInfo, Sgkc010aRequest, Sgkc007aReqTankatableShutokuinfoDto, Sgkc008aReqTankatableregistrationInfoDto, Sgkc009aReqTankatableCancelInfoDto, Sgkc010aReqTankatableApprvInfoDto } from 'sg-api';
import { UsedSgkc007aService } from '../../services/used-sgkc007a.service';
import { takeUntil } from 'rxjs/operators';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { Subject } from 'rxjs';
import { UsedSgkc008aService } from '../../services/used-sgkc008a.service';
import { UsedSgkc009aService } from '../../services/used-sgkc009a.service';
import { UsedSgkc010aService } from '../../services/used-sgkc010a.service';
import { MoneyFormatService } from '../../../../../../sg-base/sg-base-shared/services/money-format.service';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';

/**単価表登録画面
 * @export
 * @class Sgkc012dComponent
 * @implements {OnInit,OnDestroy} 
 */
@Component({
    selector: 'app-sgkc012d',
    templateUrl: './sgkc012d.component.html',
    styleUrl: './sgkc012d.component.scss',
    providers: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc012dComponent implements OnInit, OnDestroy {
    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** 画面表示モード */
    displayMode: string;
    /** 単価表コード */
    tankatableCode: string;
    /** 単価表登録管理通番 */
    tankatableregistrationManagementserialnumber: string;
    /** 単価表基本情報 */
    tankatableBasicInfo: TankatableBasicInfo;
    /** 単価表登録管理情報 */
    tankatableregistrationManageInfo: TankatableregistrationManageInfo;
    /** 単価表明細情報 */
    tankatableMeisaiList: TankatableMeisaiDto[];
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** 子コンポーネントの入力内容受取Form */
    tankatableDetailForm: UntypedFormGroup;
    /** 結果表示フラグ */
    showDetailflag: boolean = false;

    /**
    * コンストラクタ
    * @param {Router} router
    * @param {UntypedFormBuilder} fb
    * @param {ActivatedRoute} route
    * @param {UsedSgkc007aService} usedSgkc007aService
    * @param {UsedSgkc008aService} usedSgkc008aService
    * @param {UsedSgkc009aService} usedSgkc009aService
    * @param {UsedSgkc010aService} usedSgkc010aService
    * @param {MoneyFormatService} moneyFormatServiceService
    * @param {CompleteDataService} completeDataService
    * @memberof Sgkc012dComponent
     */
    constructor(private router: Router,
        private fb: UntypedFormBuilder,
        private route: ActivatedRoute,
        private usedSgkc007aService: UsedSgkc007aService,
        private usedSgkc008aService: UsedSgkc008aService,
        private usedSgkc009aService: UsedSgkc009aService,
        private usedSgkc010aService: UsedSgkc010aService,
        private moneyFormatServiceService: MoneyFormatService,
        private completeDataService: CompleteDataService,
    ) {
        this.tankatableDetailForm = this.fb.group({});
    }

    /** 
     * 初期処理
     * @memberof Sgkc012dComponent
     */
    ngOnInit(): void {
        // 画面モードを取得
        this.displayMode = this.route.snapshot.paramMap.get('mode');
        this.tankatableCode = this.route.snapshot.paramMap.get('tankatableCode');
        this.tankatableregistrationManagementserialnumber = this.route.snapshot.paramMap.get('tankatableregistrationManagementserialnumber');
        // 受信データの購読設定（単価マスタ詳細）
        this.usedSgkc007aService.tankatableDetailChanges
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(response => {
                this.tankatableBasicInfo = response.tankatableBasicInfo;
                this.tankatableregistrationManageInfo = response.tankatableregistrationManageInfo;
                this.tankatableMeisaiList = response.tankatableMeisaiInfo.tankatableMeisaiList;
            });

        // 単価表詳細取得APIのリクエストを作成
        let tankatableShutokuinfo: Sgkc007aReqTankatableShutokuinfoDto
        tankatableShutokuinfo = {
            tankatableCode: this.tankatableCode,
            tankatableregistrationManagementserialnumber: this.tankatableregistrationManagementserialnumber ? this.tankatableregistrationManagementserialnumber : null
        }
        let sgkc007aRequest: Sgkc007aRequest
        sgkc007aRequest = {
            tankatableShutokuinfo: tankatableShutokuinfo
        }
        // 単価表詳細取得APIを呼び出し
        this.usedSgkc007aService.getTankatableDetail(sgkc007aRequest)
            .subscribe(response => {
                this.showDetailflag = true;
            }, error => {
            });
    }

    /** 
    * 購読を停止する処理
    * @memberof Sgkc012dComponent
    */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** 
    * 登録ボタン押下時処理
    * @memberof Sgkc012dComponent
    */
    onClickRegistration(): void {
        // リクエストを作成する
        const formValues = this.tankatableDetailForm.getRawValue();
        // 単価情報
        const tankatableMeisaiInfoForm = formValues.tankatableMeisaiInfoForm;
        // 単価基本情報
        const tankatableBasicInfoForm = formValues.tankatableBasicInfoForm;
        // 単価基本情報配列部分
        const items = tankatableMeisaiInfoForm.items;

        // 格納用単価表明細情報
        const tankatableMeisaiList: TankatableMeisaiDto[] =
            items.map(dto => ({
                updateSrno: '00001',
                prdCode: dto.prdCode,
                goodsCode: dto.goodsCode,
                chargeCode: dto.chargeCode,
                tankaSiteiDiv1: dto.tankaSiteiDiv1,
                tankaSiteiDiv2: dto.tankaSiteiDiv2,
                tankaSiteiDiv3: dto.tankaSiteiDiv3,
                tankaSiteiDiv4: dto.tankaSiteiDiv4,
                tankaSiteiDiv5: dto.tankaSiteiDiv5,
                tankaRangeStart: Number(dto.tankaRangeStart),
                applyStartDate: tankatableMeisaiInfoForm.applyStartyearmonth.replace('-', '') + '01',
                applyEndDate: '99991231',
                tankaAname: dto.tankaAname,
                tankaRyaku: dto.tankaRyaku,
                unitPriceRangeEnd: Number(dto.unitPriceRangeEnd),
                tanka: this.moneyFormatServiceService.reformatMoney(dto.tanka) ? Number(this.moneyFormatServiceService.reformatMoney(dto.tanka)) : null,
                choseiTankaCode: dto.choseiTankaCode,
                unit: dto.unit,
                exceedUnitPrice: dto.exceedUnitPrice !== null ? Number(dto.exceedUnitPrice) : null,
                exceedUnit: dto.exceedUnit,
            })
            )

        const tankatableregistrationInfo: Sgkc008aReqTankatableregistrationInfoDto = {
            applyStartyearmonth: tankatableMeisaiInfoForm.applyStartyearmonth.replace('-', ''),
            tankatableregistrationBasicInfo: {
                tankatableCode: tankatableBasicInfoForm.tankatableCode,
                tankahyocodeRrkno: this.tankatableregistrationManageInfo.tankahyocodeRrkno
            },
            tankatableregistrationMeisaiInfo: {
                tankatableMeisaiList: tankatableMeisaiList
            },
        }            
        const sgkc008aRequest: Sgkc008aRequest = {
            tankatableregistrationInfo: tankatableregistrationInfo
        }
        this.usedSgkc008aService.registTankatable(sgkc008aRequest)
            .subscribe(response => {
                if (response) {
                    // 登録完了画面遷移
                    this.completeDataService.completeData = {
                        title: '単価表登録完了',       // 画面タイトルを設定
                        message: '単価表を登録しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc021d', // OK押下時に登録モードで検索画面に遷移する
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 取消ボタン押下時処理
    * @memberof Sgkc012dComponent
    */
    onClickDelete(): void {
        // リクエストを作成する
        const tankatableCancelInfo: Sgkc009aReqTankatableCancelInfoDto = {
            tankatableregistrationManagementserialnumber: this.tankatableregistrationManageInfo.tankatableregistrationManagementserialnumber,
            updateSrno: this.tankatableregistrationManageInfo.updateSrno
        }        
        const sgkc009aRequest: Sgkc009aRequest = {
            tankatableCancelInfo: tankatableCancelInfo
        }
        this.usedSgkc009aService.deleteTankatable(sgkc009aRequest)
            .subscribe(response => {
                if (response) {
                    // 取消完了画面遷移
                    this.completeDataService.completeData = {
                        title: '単価表取消完了', // 画面タイトルを設定
                        message: '単価表を取消しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc021d', // OK押下時に取消モードで検索画面に遷移する
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 
    * 承認ボタン押下時処理
    * @memberof Sgkc012dComponent
    */
    onClickApproval(): void {
        // リクエストを作成する
        const formValues = this.tankatableDetailForm.getRawValue();
        // 単価基本情報
        const tankatableBasicInfoForm = formValues.tankatableBasicInfoForm;
        const tankatableApprvInfo: Sgkc010aReqTankatableApprvInfoDto = {
            tankatableregistrationManagementserialnumber: this.tankatableregistrationManageInfo.tankatableregistrationManagementserialnumber,
            tankatableCode: tankatableBasicInfoForm.tankatableCode,
            updateSrno: this.tankatableregistrationManageInfo.updateSrno
        }
        const sgkc010aRequest: Sgkc010aRequest = {
            tankatableApprvInfo: tankatableApprvInfo
        }
        this.usedSgkc010aService.approveTankatable(sgkc010aRequest)
            .subscribe(response => {
                if (response) {
                    // 承認完了画面遷移
                    this.completeDataService.completeData = {
                        title: '単価表承認完了',       // 画面タイトルを設定
                        message: '単価表を承認しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc021d', // OK押下時に承認モードで検索画面に遷移する
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.displayMode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }
}
